<template>
  <div class="detailIntroduce">
    <div class="row title">标题：{{data.title}}</div>
    <div class="row">讲者：{{data.name}}</div>
    <div v-show="data.value2" class="row">讲者所在医院：{{data.value2}}</div>
    <div :class="status ? 'row introduce' : 'off row introduce'">
      <div v-show="!status" class="btn gengduo" @click="status = 1">更多</div>
      <div>
        会议介绍：<span class="mmmmm" v-html="data.value1"></span>
        <div v-show="status" class="btn" @click="status = 0">收起</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailIntroduce",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      status: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.mmmmm {
  white-space: pre-wrap;
}
.detailIntroduce {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 25px 25px;
  .btn {
    background: #ECECEC;
    width: 80px;
    height: 50px;
    font-size: 22px;
    color: #00476C;
    text-align: center;
    line-height: 50px;
  }
  .introduce {
    position: relative;
    .gengduo {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .off {
    height: 50px;
    overflow: hidden;
  }
  .row {
    line-height: 45px;
    font-size: 28px;
    color: #999999;
    width: 100%;
    text-align: left;
  }
  .title {
    color: #333333;
    font-size: 30px;
  }
}
</style>
